import React from 'react'

import type { Package } from '../../../../../../core/typings'
import { TakeAwayDetailsBlock } from './TakeAwayDetailsBlock'
import { DeliveryChannel } from '../../../../constants'
import { PickupDetailsBlock } from './PickupDetailsBlock'
import { DeliveryDetailsBlock } from './DeliveryDetailsBlock'

export type PackageDetailsBlockProps = {
  currentPackage: Package
}

export const PackageDetailsBlock = ({
  currentPackage,
}: PackageDetailsBlockProps) => {
  if (currentPackage.selectedSlaType === DeliveryChannel.TakeAway) {
    return <TakeAwayDetailsBlock />
  }

  if (currentPackage.selectedSlaType === DeliveryChannel.PickupInPoint) {
    return <PickupDetailsBlock currentPackage={currentPackage} />
  }

  return <DeliveryDetailsBlock currentPackage={currentPackage} />
}
